<template>
  <div class="slide-navigation-item m-2 p-0 btn btn-secondary" tabindex="0" :class="{ 'disabled': disabled }"
    @click.prevent="$emit('goToSlide', slide.id)">
    <div class="p-2 text-light rounded-top" :class="{ 'bg-theme': active }">
      <h6 class="text-truncate mb-0">{{ title }}</h6>
    </div>
    <PreviewSlide :slide="slide" />
    <div class="p-2 text-light d-flex justify-content-between align-items-center rounded-bottom" :class="{ 'bg-theme': active }">
      <span class="font-weight-bold">{{ slide.position }}</span>
      <div>
        <AVIcon v-if="isBallot && (slide as BallotSlide).state == 'finished'" icon="poll" class="me-1" v-tooltip="$t('js.tooltips.result_ready')" />
        <AVIcon v-if="typeIcon" :icon="typeIcon" v-tooltip="$t('js.tooltips.ballot')" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import PreviewSlide from "./PreviewSlide.vue";
import { useSharedStore } from "@/entrypoints/stores/shared";
import type { BallotSlide, PropType, Slide } from "@/types";
import { onMounted } from "vue";

const { t } = useI18n();

const sharedStore = useSharedStore();

const props = defineProps({
  active: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  slide: {
    type: Object as PropType<Slide>,
    default: () => { return { type: "none" } },
  },
});

const title = computed(() => {
  let title = (props.slide as BallotSlide).internalName
    ? (props.slide as BallotSlide).internalName
    : props.slide.title[sharedStore.firstAvailableLocale];

  if (title === "" || title === undefined)
    title = t("js.slide", { n: 1 }) + " #" + props.slide.position;

  return title;
});

const isBallot = computed(() => props.slide.type === "Slides::BallotSlide");

const typeIcon = computed(() => {
  if (isBallot.value) return "vote-yea";
});

onMounted(() => $('[data-bs-toggle="tooltip"]').tooltip());
</script>
